import { Component, Inject, OnInit,Input,Output,EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from "../../../../../environments/environment";
import { UserService } from 'src/app/providers/user.service';
import { AuthService } from 'src/app/providers/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/app/providers/common.service';
import { apiLinks } from 'src/app/core/api-links/api-links';
import { Users } from 'src/app/core/model/user';
import { MessageService } from 'primeng/api';
import { DOCUMENT } from '@angular/common';
import { isEmpty } from 'lodash';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TermsAndconditionComponent } from '../../terms-condition/terms-condition.component';
import { PasskeyComponent } from 'src/app/shared/components/passkey/passkey.component';
import { TranslateService } from "@ngx-translate/core";
import { ErrorCode } from 'src/app/core/model/common';

@Component({
  selector: 'app-multi-factor-auth',
  templateUrl: './multi-factor-auth.component.html',
  styleUrls: ['./multi-factor-auth.component.scss']
})
export class MultiFactorAuthComponent implements OnInit {

  @Input() widthClass = 'col-md-10 col-xl-6';
  @Input() native = 'auth';
  @Output() afterSuccessVerifyOtp = new EventEmitter<any>();
  @Output() onError = new EventEmitter<any>();
  @Output() onBack = new EventEmitter<any>();
  @Input() title = "Hello there,";
  @Input() content = "Multi Factor Authentication (MFA) keeps your account safe from password hacks.";
  @Input() mfaData:any = {};
  @Input() apiName='';
  @Input() httpOptions={};
  @Input() formData={};
  @Input() showBackButton=false;
  @Input() isFullWidth=false;
  loginLogo:any
  tagName:any
  imageUrl = environment.whitelabelLogoPath;
  termsAllowUsers : any
  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    public commonService: CommonService,
    private translate: TranslateService,
    private messageService: MessageService,private  modalService: NgbModal,
    @Inject(DOCUMENT) private document: Document
  ) { }
  environmentData = environment;
  mfaForm: FormGroup = this.fb.group({
    otp: [null, [Validators.required, Validators.maxLength(6)]],
    agreed: [false]
  })
  checkAgreed: boolean = false;
  loaders = {
    logging: false,
    timer: false
  }
  TIMER = 60
  timer = this.TIMER
  intervalId
  user: Users
  returnUrl = "/"
  resendOTPApiName;
  resendOTPPayload={};
  userId: any | null = null;
  showTermsModal = false;
  showTermsCheck = false;
  passkey_setup: boolean = false;
  isPasswordResetFlow = false;
  showBrandClass = true

  ngOnInit(): void {
    let whitelabelResData = JSON.parse(localStorage.getItem('whitelabelResData'));
    const mfaSession = JSON.parse(localStorage.getItem('mfa_session') || 'null');
    this.termsAllowUsers = JSON.parse(localStorage.getItem('terms_allow_user') || 'null');
     this.route.queryParams.subscribe((params) => {
      this.passkey_setup = params['passkey_setup'] === 'true';
    });
    if (!isEmpty(whitelabelResData)) {
      this.loginLogo = `${this.imageUrl}/${whitelabelResData.logo_Login}`
      this.tagName = whitelabelResData.tagName
      whitelabelResData.logo_dashboard = `${this.imageUrl}/${whitelabelResData.logo_dashboard}`
      this.showBrandClass = false

    }
    this.mfaForm.get('agreed')?.valueChanges.subscribe((value) => {
      this.checkAgreed = value;
    });
    if (this.native == 'auth') {
      this.authService.defaultTheme();
      this.user = this.authService.getUser
      this.apiName = apiLinks.mfa.verifyOTP;
      if (mfaSession?.isPasswordReset) {
        this.isPasswordResetFlow = true;
        if (!mfaSession?.id || !mfaSession?.email) {
          this.router.navigate(['/auth/login']);
          return;
        }
        this.mfaData = {
          email: mfaSession.email,
          id: mfaSession.id,
          whitelabelData: (whitelabelResData?.domainName == environment?.portalUrl ||
                           whitelabelResData?.domainName == 'https://ipospays.tech') ? null : whitelabelResData
      };
      this.resendOTPApiName = apiLinks.mfa.resendOTP;
      this.resendOTPPayload = this.mfaData;
      this.user = {
        email: mfaSession.email,
        phoneNumber: mfaSession.phoneNumber,
        userType: mfaSession.userType
      } as any;
    } else if (!(this.user?.id && this.user?.email)) {
      if (mfaSession?.id && mfaSession?.email) {
        this.mfaData = {
        email: mfaSession.email,
        id: mfaSession.id,
        whitelabelData: (whitelabelResData?.domainName == environment?.portalUrl ||
                        whitelabelResData?.domainName == 'https://ipospays.tech') ? null : whitelabelResData
        };
        this.resendOTPApiName = apiLinks.mfa.resendOTP;
        this.resendOTPPayload = this.mfaData;
        this.user = {
        email: mfaSession.email,
        phoneNumber: mfaSession.phoneNumber,
        userType: mfaSession.userType,
        isTermsCheck: mfaSession.isTermsCheck
        } as any;
    } else {
        this.router.navigate(['/auth/login']);
    }
    } else {
    this.mfaData = {
        email: this.user.email,
        id: this.user?.id,
        whitelabelData: (whitelabelResData?.domainName == environment?.portalUrl || whitelabelResData?.domainName == 'https://ipospays.tech') ? null : whitelabelResData
    };
    this.resendOTPApiName = apiLinks.mfa.resendOTP;
    this.resendOTPPayload = this.mfaData;
    }

    } else {
      if (!this.mfaData?.uiRefId) {
        this.onError.next({message:"Invalid Request !"});
      }
      this.resendOTPApiName = apiLinks.mfa.resendOTPWithUiRefId;
      this.resendOTPPayload = {
        uiRefId:this.mfaData?.uiRefId,
        whitelabelData: (whitelabelResData?.domainName == environment?.portalUrl || whitelabelResData?.domainName == 'https://ipospays.tech') ? null : whitelabelResData
      };
    }

    const psi = localStorage.getItem("psi")

    this.addScriptElement(psi)
    if (!this.termsAllowUsers?.length) {
      this.showTermsCheck = false;
    } else {
      this.showTermsCheck = this.termsAllowUsers.includes(this.user?.userType) && !this.user?.isTermsCheck;
    }
    if (this.isPasswordResetFlow) {
      this.showTermsCheck = false;
    }
  }

  setTimer = () => {
    this.intervalId = setInterval(() => {
      if ( this.timer > 0) {
        this.timer = this.timer - 1
      }
    }, 1000)
  }

  async onResendCode() {
    this.loaders.timer = !this.loaders.timer
    if (!this.mfaData?.id && !this.mfaData?.uiRefId) {
      return
    }
    try {

      this.setTimer()
      const resendCodeRes = await this.commonService.postCommonHttpClient(this.resendOTPApiName, this.resendOTPPayload).toPromise()
      const { message } = resendCodeRes;
      if (resendCodeRes?.toaster_type == 'MODAL' && message) {
        this.authService.showModal({ message });
      } else {
        this.showSuccessToast(message)

      }

      setTimeout(() => {
        clearInterval(this.intervalId)
        this.loaders.timer = !this.loaders.timer
        this.timer = this.TIMER
      }, (this.TIMER  - 1) * 1000);

    }
    catch (err) {
      clearInterval(this.intervalId)
      this.loaders.timer = false
      // shoe notifications
      this.messageService.clear();
      if (err.type == 'MODAL') {
        this.authService.showModal(err);
      } else {
        this.showErrorToast(err.message)
      }
    }
  }

  async onCancel() {
    if(this.native == 'auth'){
      localStorage.removeItem('mfa_session');
      localStorage.removeItem('mfa_pending');
      sessionStorage.removeItem(this.commonService.sessionStorageKeys.passwordReset);
      window.open("/auth/login", "_self")
      localStorage.removeItem("current_user");
    }else{
      this.onBack.next(true)
    }
  }

  async onVerifyOtp(data) {
    const { otp } = this.mfaForm.value
    const agreed = this.checkAgreed;

    if (!otp) return
    if (this.showTermsCheck && !agreed) return;

    const isPasswordResetVerification = this.isPasswordResetFlow || this.isStoredPasswordResetFlow();
    this.loaders.logging = true
    try {
      const verifyOtp = await this.commonService.postCommonHttpClient(
        this.apiName, {
        ...(this.native == 'auth'?this.mfaData:this.formData),
        otp,isTermsCheck : this.checkAgreed,UserRoleType:this.user?.userType,passkey_setup:this.passkey_setup,isPasswordReset: isPasswordResetVerification

      },this.httpOptions).toPromise()
      if(verifyOtp.passkeySetup){
        this.returnUrl = this.route.snapshot.queryParams["returnUrl"] || "/";
         let modalRef = this.modalService.open(PasskeyComponent, { ariaLabelledBy: 'modal-basic-title', centered: true, backdrop: 'static', keyboard: false });
          modalRef.componentInstance.isLoading = true
          modalRef.componentInstance.logIntoSetUp = true;
          modalRef.componentInstance.header = `LOGIN-AS CONFIRMATION`;
      }else {
          this.returnUrl = this.route.snapshot.queryParams["returnUrl"] || "/";
      }

      if (this.native == "auth") {
         if (isPasswordResetVerification) {
            const resetToken = this.getPasswordResetToken(verifyOtp);
            const resetUserId = this.getPasswordResetUserId(verifyOtp);
            if (!resetToken || !resetUserId) {
              this.loaders.logging = false;
              this.showErrorToast("Something Happened , Please try again later!")
              return;
            }
            sessionStorage.setItem(this.commonService.sessionStorageKeys.passwordReset, JSON.stringify({
              userId: resetUserId,
              token: resetToken
            }));
            localStorage.removeItem('mfa_session');
            localStorage.removeItem('mfa_pending');
            this.router.navigate(['/userVerify']);
            return;
          }
        if (verifyOtp?.accessToken) {
          localStorage.removeItem('mfa_session');
          this.authService.setUser(verifyOtp);
          localStorage.setItem("logger_token", "multiLogin");
    
            //ISV users should be redirected to user-management/users page
            if (verifyOtp?.userType === 'ISV') {
              this.router.navigateByUrl('/user-management/users');
              return;
            }

            if (verifyOtp?.userType == 'MULTI_STORE_MANAGER') {
              this.navigateToReturnUrl(this.route.snapshot.queryParams["returnUrl"] || '/user-management/users');
            } else {
              const excludeFeatures = verifyOtp && verifyOtp.excludeFeatures || [];
              if(excludeFeatures.indexOf('VIEW_DASHBOARD') > -1){
                const { roleFeatures } = verifyOtp;
                const featureExists = (module, feature) => roleFeatures.some(item => item.module === module && item.features.includes(feature));
                this.router.navigateByUrl(
                  featureExists("CLOUD_POS", "PAYMENTS")
                    ? '/virtual-terminal/list'
                    : featureExists("TRANSACTION", "VIEW_TRANSACTION")
                      ? '/transaction-management/transactions'
                      : '/user-management/users'
                );
              }else{
                this.navigateToReturnUrl(this.returnUrl);
              }
            }
        }
        else {
          this.loaders.logging = false;
          this.messageService.clear();
          this.showErrorToast("Something Happened , Please try again later!")
        }

      } else {
         console.log("isComing the afterSuccessVerifyOtp", verifyOtp)
        this.afterSuccessVerifyOtp.next(verifyOtp);
        
      }

    }

    catch (err) {    
      this.messageService.clear();
       if (err?.type == 'MODAL' || err?.error?.type == 'MODAL') {
        const errObj = { ...err, ...err?.error };
        const errorCode = errObj?.code;
        if (errorCode === ErrorCode.PASSWORD_EXPIRED) {
          errObj.okBtnAction = errorCode;
          this.translate.get('htmlText.RESET_PASSWORD').subscribe((btnLabel: string) => {
            errObj.okBtnLabel = btnLabel;
            this.authService.showModal({
              ...errObj,
              closeOnOk: false
            }, (modalRef: any) => this.startPasswordResetFromExpiredModal(errObj, modalRef));
          });
        } else {
          this.authService.showModal({
            ...errObj,
            okBtnAction: errorCode
          });
        }
      } else {
        this.showErrorToast(err.message)
      }
      this.loaders.logging = false

    }
  }

  showErrorToast(detail: string) {
    this.messageService.add({ severity: 'error', summary: 'Error', detail, sticky: true, key: 'mfa-toast' })
  }

  showSuccessToast(detail: string) {
    this.messageService.add({ severity: 'success', summary: 'Success', detail, life: 7000, key: 'mfa-toast' })
  }

  private getPasswordResetToken(response: any): string | null {
    const token = typeof response?.token === 'string'
      ? response.token.trim()
      : typeof response?.data?.token === 'string'
        ? response.data.token.trim()
        : '';
    return token || null;
  }

  private getPasswordResetUserId(response: any): string | null {
    const userId = response?.userId || response?.data?.userId || response?.id || response?.data?.id;
    const resetUserId = userId ? `${userId}`.trim() : '';
    return resetUserId || null;
  }

  private isStoredPasswordResetFlow(): boolean {
    try {
      const mfaSession = JSON.parse(localStorage.getItem('mfa_session') || 'null');
      return mfaSession?.isPasswordReset === true || mfaSession?.isPasswordReset === 'true';
    } catch {
      return false;
    }
  }

  private startPasswordResetFromExpiredModal(errObj: any, modalRef: any): void {
    const storedMfaSession = JSON.parse(localStorage.getItem('mfa_session') || 'null');
    const resetEmail = errObj?.email || this.mfaData?.email || storedMfaSession?.email || this.user?.email;
    const resetSessionId = this.mfaData?.id || storedMfaSession?.id;
    if (!resetEmail || !resetSessionId) {
      this.showErrorToast("Something Happened , Please try again later!")
      return;
    }

    if (modalRef) modalRef.componentInstance.spinLoader = true;
    sessionStorage.removeItem(this.commonService.sessionStorageKeys.passwordReset);
    this.userService.passwordResetMFA({
      id: resetSessionId,
      email: resetEmail
    }).subscribe(
      (resetRes: any) => {
        if (modalRef) modalRef.close();
        const resetToken = this.getPasswordResetToken(resetRes);
        const resetUserId = this.getPasswordResetUserId(resetRes);
        if (!resetToken || !resetUserId) {
          this.showErrorToast("Something Happened , Please try again later!")
          return;
        }

        sessionStorage.setItem(this.commonService.sessionStorageKeys.passwordReset, JSON.stringify({
          userId: resetUserId,
          token: resetToken
        }));
        localStorage.removeItem('mfa_session');
        localStorage.removeItem('mfa_pending');
        this.router.navigate(['/userVerify']);
      },
      (resetErr) => {
        if (modalRef) modalRef.componentInstance.spinLoader = false;
        this.showErrorToast(resetErr?.message || 'Unable to initiate password reset. Please try again.');
      }
    );
  }

  addScriptElement(psiUrl: string) {

    if ( !psiUrl) return
    const node = document.createElement('script');
    node.id = "mem-id";// creates the script tag
    node.src = psiUrl; // sets the source (insert url in between quotes)
    node.type = "text/javascript"  // set the script type
    node.async = true; // makes script run asynchronously
    node.defer = true; // prevents script from blocking HTML parsing
    node.referrerPolicy = "strict-origin-when-cross-origin"; // limits how much referrer information is sent to Memyco servers
    // append to head of document
    document.getElementsByTagName('head')[0].appendChild(node);

    const mem = document.getElementById("mem-id")
    console.log("mem added")
  }

  ngOnDestroy() {
    const mem = document.getElementById("mem-id")
    if (mem) {
      mem.remove()
    }
    console.log("mem removed:", mem)
  }

  openTermsModal(event: Event): void {
    event.preventDefault();
    const fileUrl = apiLinks?.loadTermsPdf
    sessionStorage.setItem('termsPdfUrl', fileUrl);
    window.open(`/terms-condition`, '_blank');
  }

  /**
   * Navigates to returnUrl. If it is an absolute URL (e.g. VMS at localhost:4300),
   * performs a full page redirect via window.location; otherwise uses Angular router.
   */
  private navigateToReturnUrl(url: string): void {
    if (url && (url.startsWith('http://') || url.startsWith('https://'))) {
      window.location.href = url;
    } else {
      this.router.navigateByUrl(url || '/');
    }
  }

}